// extracted by mini-css-extract-plugin
export var innerMobileHeroBg = "Hero2-module--inner-mobile-hero-bg--7cc22";